/**
 * @module app.shared
 */

// source: https://stackoverflow.com/a/2117523

export type guid = string;

/**
 * @note While this function does generate guids, it should only be used for element IDs and other similar, client-only functionality. (Matt)
 */
export function guid(): guid {
  return (''+1e7+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    // @ts-ignore: Intended value coersion
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
